import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bbb3aa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "active"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "icon is-small" }
const _hoisted_4 = {
  key: 0,
  class: "section-card"
}
const _hoisted_5 = { class: "custom-card-title title-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_CurrencyItem = _resolveComponent("CurrencyItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.adminUserAccounts.length)
      ? (_openBlock(), _createBlock(_component_loading, {
          key: 0,
          active: _ctx.currenciesLoading,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currenciesLoading) = $event)),
          "can-cancel": false,
          "is-full-page": false
        }, null, 8, ["active"]))
      : _createCommentVNode("", true),
    (!_ctx.currenciesLoading || _ctx.adminUserAccounts.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleRefreshBalance())),
            title: _ctx.$gettext('Refresh balance and transaction list'),
            class: _normalizeClass(["button is-default is-pulled-right is-rounded refresh", {
        'active-refresh-button': _ctx.currencyRefreshing,
      }])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass({ hide: _ctx.currencyRefreshing })
            }, _toDisplayString(_ctx.$gettext("Refresh")), 3),
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_fa_icon, {
                class: _normalizeClass({
            refreshing: _ctx.currencyRefreshing,
          }),
                icon: "sync"
              }, null, 8, ["class"])
            ])
          ], 10, _hoisted_2),
          (_ctx.adminUserAccounts.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$gettext("your currencies")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adminUserAccounts, (entry) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    _createVNode(_component_CurrencyItem, {
                      class: _normalizeClass(["mb-5", {
            selected: entry.userAccount?.internalId === _ctx.currency?.internalId,
          }]),
                      onCurrencySelected: ($event: any) => (_ctx.$emit('currencySelected', entry.userAccount)),
                      isCurrencySelected: 
            entry.userAccount?.internalId === _ctx.currency?.internalId
          ,
                      currency: entry.userAccount,
                      showAccountId: entry.showAccountId,
                      refreshCurrency: _ctx.refreshCurrency,
                      "onUpdate:currencyRefreshing": _cache[2] || (_cache[2] = (x) => (_ctx.currencyRefreshing = x))
                    }, null, 8, ["class", "onCurrencySelected", "isCurrencySelected", "currency", "showAccountId", "refreshCurrency"])
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}